// extracted by mini-css-extract-plugin
var _1 = "_settings-module__product-settings-container";
var _2 = "_settings-module__tab-display";
var _3 = "_settings-module__title";
export { _1 as "product-settings-container", _2 as "tab-display", _3 as "title" }
